/*******************************************************************
* PAGE        : SnackbarsComponent
* REMARKS     : Comman Snackbars Component
* CREATED ON  : 03-11-2025
* AUTHOR      : Bamroliya.Paras
* MODIFY      : Bamroliya.Paras
* MODIFY ON   : 24-02-2026
********************************************************************/

import Alert from '@mui/material/Alert';
import CloseIcon from '@mui/icons-material/Close';
import Fade from '@mui/material/Fade';
import IconButton from '@mui/material/IconButton';
import Snackbar from '@mui/material/Snackbar';
import * as React from 'react';

const SnackbarsComponent = ({ isOpen, message, onClose, severity }) => {
    const [open, setOpen] = React.useState(isOpen);

    const handleClose = (event, reason) => {
        if (reason === 'clickaway') {
            return;
        }
        setOpen(false);
        if (onClose) onClose(false);  // Callback to update parent state
    };

    React.useEffect(() => {
        setOpen(isOpen); // When the `isOpen` prop changes, update the local state
    }, [isOpen]);

    // severity = success, info, warning, error
    // variant = notPassed, filled, outlined
    return (
        <Snackbar open={open} autoHideDuration={4000} onClose={handleClose} anchorOrigin={{ vertical: "top", horizontal: "center" }} slots={{ transition: Fade }}>
            <Alert
                severity={severity}
                variant="filled"
                sx={{ width: '100%' }}
                action={
                    <IconButton
                        size="small"
                        disableRipple
                        onClick={handleClose}
                        sx={{ color: '#fff' }}
                    >
                        <CloseIcon fontSize="small" sx={{ color: '#fff' }} />
                    </IconButton>
                }
            >
                {message}
            </Alert>
        </Snackbar>
    );
}

export default SnackbarsComponent;
